import styled from "styled-components";

export const SOnboardingTemplatesModal = styled.div`
  height: calc(100vh - 80px);
  width: calc(100vw - 80px);
  max-width: 1200px;
`;
